﻿'use strict';

// TODO: write unit tests
var events = {};

module.exports = {
    off: function (widget, event) {
        if (!event) {
            delete events[widget.id];
        } else {
            delete events[widget.id][event];
        }
    },
    on: function (widget, event, callback) {
        if (!events[widget.id]) {
            events[widget.id] = {};
        }

        if (!events[widget.id][event]) {
            events[widget.id][event] = [];
        }

        events[widget.id][event].push(callback);
    },
    rise: function (widget, event) {
        var index,
            args = Array.prototype.slice.call(arguments, 2),
            widgetEvents;

        if (!events[widget.id] || !events[widget.id][event]) {
            return;
        }

        widgetEvents = events[widget.id][event];

        for (index = 0; index < widgetEvents.length; index++) {
            widgetEvents[index].apply(widget, args);
        }
    }
};



//////////////////
// WEBPACK FOOTER
// ./src/widget/scripts/lib/commons/events/eventing.js
// module id = 7
// module chunks = 0 1